import type { PageCard } from '@/play/pageTypes'
import { SnowCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'snow',
  number: 15,
  title: 'Snow',
  question: 'Does snow as a soft rounded surface that settles over things feel like snow?',
  status: 'open',
  accent: '#e6eef6',
  CardArt: SnowCardArt,
}
